export default __webpack_public_path__ + "08385ffa29076d786fddd1f79d93ad5c.png";